import { type DocumentType, graphql } from '@/gql';

import { FileManagerEmptyFolder } from './FileManagerEmptyFolder';
import { FileManagerGettingStarted } from './empty-root-folder/FileManagerGettingStarted';

const FILE_MANAGER_EMPTY_ROOT_FOLDER_FILES_FOR_OWNER_FRAGMENT = graphql(`
  fragment fileManagerEmptyRootFolderFilesForOwnerFields on FilesForOwner {
    ...fileManagerGettingStartedFilesForOwnerFields
  }
`);

interface Props {
  filesForOwner: DocumentType<
    typeof FILE_MANAGER_EMPTY_ROOT_FOLDER_FILES_FOR_OWNER_FRAGMENT
  >;
}

export const FileManagerEmptyRootFolder = ({ filesForOwner }: Props) => {
  const { owner } = filesForOwner;
  const { __typename } = owner;

  return __typename === 'Group' ? (
    <FileManagerGettingStarted filesForOwner={filesForOwner} />
  ) : (
    <FileManagerEmptyFolder />
  );
};
